<template>
    <div
        v-if="screen.minLG"
        :class="[
            'flex-none hidden mb-10 min-w-75 max-w-75 lg:block lg:ml-8 xl:ml-[5.25rem]',
            { 'md:mt-16': topSpacing },
        ]"
    >
        <slot />

        <template v-if="isLoggedIn">
            <div
                :class="{ sticky: isAdSticky }"
                :style="{ top: '100px' }"
            >
                <Xandr
                    xandr-wrapper="mrecWrapper"
                    xandr-slot="mrec"
                    class="mb-4"
                ></Xandr>
            </div>

            <FooterAuth arrangement="vertical" />

            <!-- via this sticky container, we get informed when the ad should be sticky -->
            <StickyContainer
                :offset="100"
                class="h-1 mt-4"
                @sticky="isAdSticky = $event"
            />
        </template>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import StickyContainer from '@/components/StickyContainer';
import { Xandr } from '@/components/Xandr';
import { FooterAuth } from '@/components/TheFooter';

export default defineComponent({
    name: 'TheRightSidebar',
    components: {
        StickyContainer,
        FooterAuth,
        Xandr,
    },
    props: {
        /**
         * Whether or not to have a fixed margin on top.
         */
        topSpacing: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isAdSticky: false,
        };
    },
    computed: {
        ...mapGetters({
            isLoggedIn: 'auth/isLoggedIn',
            screen: 'ui/screen',
        }),
    },
});
</script>
